<template>
    <div class="skeleton-loader">
        <div v-for="item in transformArr">
        <vue-skeleton-loader :height="skeletonHeight"></vue-skeleton-loader>
        </div>

    </div>
</template>


<script>
import VueSkeletonLoader from 'skeleton-loader-vue';

export default {
    components: {
        VueSkeletonLoader
    },
    computed:{
        transformArr(){
            const arr = []
            for(let x=0; x<this.noOfCell; x++){
                arr.push(x)
            }

            return arr
        }
    },
    props: {
        skeletonHeight: {
            type: Number,
            default: 200
        },
        noOfCell: {
            type: Number,
            default: 4
        }
    }
}
</script>

<style scoped>
.skeleton-loader {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

@media screen and (max-width: 430px) {
    .skeleton-loader {
        grid-template-columns: 1fr;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/SkeletonLoader.vue